import styled from 'styled-components'

import { fromMd, pageLayoutMaxWidthPixels } from '@syconium/little-miss-figgy'

export const Body = styled.section`
  max-width: ${pageLayoutMaxWidthPixels}px;
  margin-left: auto;
  margin-right: auto;

  padding: 52px 0;
  text-align: center;

  ${fromMd} {
    padding: 188px 0 116px;
    width: 100%;
  }
`

export const SvgText = styled.g<{
  inViewport?: boolean
}>`
  transition: transform 2s ease 1s;
  transform: ${o => !o.inViewport && 'rotate(-225deg)'};
  transform-origin: 50% 50%;
`

export const IconWrap = styled.div`
  svg {
    fill: currentColor;
    width: 100px;
  }

  ${fromMd} {
    display: inline-block;
    margin-inline-end: 80px;
    vertical-align: middle;

    svg {
      width: 130px;
    }
  }
`

export const SlantedLine = styled.div`
  border-right: solid 0.7px currentColor;
  display: inline-block;
  height: 20px;
  margin: 28px auto;
  opacity: 0.74;
  transform: rotate(45deg);
  width: 1px;

  ${fromMd} {
    height: 32px;
    margin: 0;
    transform: rotate(22deg);
    vertical-align: middle;
  }
`

export const Text = styled.p`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1.75;
  padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;

  ${fromMd} {
    display: inline-block;
    line-height: 1.63;
    margin: 0 0 0 48px;
    vertical-align: middle;
    width: 460px;
  }
`

export const MessageText = styled.span`
  display: block;

  ${fromMd} {
    display: inline;
  }
`

export const Highlight = styled.span`
  font-weight: 700;
  text-transform: uppercase;
`
